import { NgModule } from '@angular/core';
import { BatchesGridResolver } from 'common/resolvers/page-resolvers/batches/batches-grid.resolver';
import { AssignmentGridResolver } from 'common/resolvers/page-resolvers/assignment/asssignment.-grid.resolver';
import { BranchesFormResolver } from 'common/resolvers/page-resolvers/branches/branches-form.resolver';
import { BranchesGridResolver } from 'common/resolvers/page-resolvers/branches/branches-grid.resolver';
import { HelpFormResolver } from 'common/resolvers/page-resolvers/help/help-form.resolver';
import { LoginResolver } from 'common/resolvers/page-resolvers/notification/login.resolver';
import { NotificationFormResolver } from 'common/resolvers/page-resolvers/notification/notification-form.resolver';
import { NotificationGridResolver } from 'common/resolvers/page-resolvers/notification/notification-grid.resolver';
import { AssignmentFormResolver } from 'common/resolvers/page-resolvers/assignment/assignment-form.resolver';
import { BatchesFormResolver } from 'common/resolvers/page-resolvers/batches/batches-form.resolver';
import { RegisterFormResolver } from 'common/resolvers/page-resolvers/preselection/admin/student/register-form-resolver';

import { AuthGuard } from 'common/guards/auth.guard';
import { BranchCategoryGridResolver } from 'common/resolvers/page-resolvers/branch-category/branch-category-grid.resolver';
import { BranchCategoryFormResolver } from 'common/resolvers/page-resolvers/branch-category/branch-category-form.resolver';
import { TrainersGridResolver } from 'common/resolvers/page-resolvers/Trainers/trainers-grid.resolver';
import { TrainersFormResolver } from 'common/resolvers/page-resolvers/Trainers/trainers-form.resolver';

import { StudentProfileResolver } from 'common/resolvers/page-resolvers/student-profile/student-profile.resolver';
import { LocationFormResolver } from 'common/resolvers/page-resolvers/location/location-form-resolver';
import { LocationGridResolver } from 'common/resolvers/page-resolvers/location/location-grid-resolver';
// import { AddStudentResolver } from 'common/resolvers/page-resolvers/student-profile/add-student.resolver';
import { ReportsNavigationResolver } from 'common/resolvers/page-resolvers/reports/reports.resolver';
import { ResultReportsResolver } from 'common/resolvers/page-resolvers/reports/result-reports.resolver';
import { InvitedGridResolver } from 'common/resolvers/page-resolvers/assignment/invited-grid.resolver';
import { StudentsFormResolver } from 'common/resolvers/page-resolvers/students/students-form.resolver';
import { StudentsGridResolver } from 'common/resolvers/page-resolvers/students/students-grid.resolver';
import { UsersGridResolver } from 'common/resolvers/page-resolvers/users/users-grid.resolver';
import { UsersFormResolver } from 'common/resolvers/page-resolvers/users/users-form.resolver';
import { applicantDashboardResolver } from 'common/resolvers/page-resolvers/preselection/admin/applicants/applicant-dashboard.resolver';
import { OtpFormResolver } from 'common/resolvers/page-resolvers/login/otp-form.resolver';
import { StudentDetailsFormResolver } from 'common/resolvers/page-resolvers/students/student-details.resolver';
import { InternshipDetailsFormResolver } from 'common/resolvers/page-resolvers/Internship-Details/internship-Details.resolver';
import { AssigmentNotAcceptedGridResolver } from 'common/resolvers/page-resolvers/assignment/assignment-not-accepted-grid.resolver';
import { ViewTrainersGridResolver } from 'common/resolvers/page-resolvers/Trainers/view-trainers-grid.resolver';
// import { StudentDetailsGridResolver } from 'common/resolvers/page-resolvers/students/student-details.resolver';
// import { StudentDetailsGridResolver } from 'common/resolvers/page-resolvers/students/student-details.resolver';
import { AssigmentAcceptedGridResolver } from 'common/resolvers/page-resolvers/assignment/assignment-accepted-grid.resolver';
import { GroupsGridResolver } from 'common/resolvers/page-resolvers/groups/groups-grid.resolver';
import { TrainerViewGridResolver } from 'common/resolvers/page-resolvers/assignment/trainers-view-grid.resolver';
import { GroupDetailResolver } from 'common/resolvers/page-resolvers/groups/student-list.resolver';
import { EmailTemplateGridResolver } from 'common/resolvers/page-resolvers/email-template/email-template-grid.resolver';
import { EmailTemplateFormResolver } from 'common/resolvers/page-resolvers/email-template/email-template-form.resolver';
import { TypesGridResolver } from 'common/resolvers/page-resolvers/types/types-grid.resolver';
import { TypesFormResolver } from 'common/resolvers/page-resolvers/types/types-form.resolver';
//import { ViewTypesFormResolver } from 'common/resolvers/page-resolvers/types/view-types-form.resolver';
//import { ViewTypesFormResolver } from 'common/resolvers/page-resolvers/types/types-form.resolver';
import { CompanyGridResolver } from 'common/resolvers/page-resolvers/internship-company/internship- company-grid.resolver';
import { ForgotPasswordFormResolver } from 'common/resolvers/page-resolvers/login/forgotPassword-form.resolver';
import { ResetForgotPasswordFormResolver } from 'common/resolvers/page-resolvers/login/resetpassword-form.resolver';
import { CompanyLocationGridResolver } from 'common/resolvers/page-resolvers/internship-company/internship-company-location-grid.resolver';
import { CompanyMentorGridResolver } from 'common/resolvers/page-resolvers/internship-company/internship-company-mentor-grid.resolver';
import { CompanyFormResolver } from 'common/resolvers/page-resolvers/internship-company/internship-company-form.resolver';
import { FeedbackGridResolver } from 'common/resolvers/page-resolvers/feedback/feedback-grid.resolver';
import { FeedbackFormResolver } from 'common/resolvers/page-resolvers/feedback/feedback-form.resolver';
import { InternshipListGridResolver } from 'common/resolvers/page-resolvers/internship-list/internship-list.resolver';
import { ApplicantsResolver } from 'common/resolvers/page-resolvers/preselection/admin/applicants/applicants.resolver';
import { TravelReimbursementGridResolver } from 'common/resolvers/page-resolvers/travel-reimbursement/travel-grid.resolver';
import { TravelReimbursementFormResolver } from 'common/resolvers/page-resolvers/travel-reimbursement/travel-form.resolver';

import { StudentAssignmentOverviewResolver } from 'common/resolvers/page-resolvers/students/student-assignment-overview.resolver';
import { documentListDataService } from 'common/services/data-services/custom-service/documentlist-service';
import { FeedbackMappingGridResolver } from 'common/resolvers/page-resolvers/feedback-mapping/feedback-mapping-grid.resolver';
import { FeedbackMappingFormResolver } from 'common/resolvers/page-resolvers/feedback-mapping/feedback-mapping-form.resolver';
import { MentoringDocumentGridResolver } from 'common/resolvers/page-resolvers/mentoring-doc/mentoring-grid.resolver';
import { MentoringDocumentFormResolver } from 'common/resolvers/page-resolvers/mentoring-doc/mentoring-form.resolver';
import { CreditGridResolver } from 'common/resolvers/page-resolvers/credit/credit-grid.resolver';
import { CreditFormResolver } from 'common/resolvers/page-resolvers/credit/credit-form.resolver';
import { studentFeedbackGridResolver } from 'common/resolvers/page-resolvers/student-feedback/student-feedback-resolver';
import { FeedbackPreviewResolver } from 'common/resolvers/page-resolvers/feedback/feedback-preview.resolver';
import { packageListDataService } from 'common/services/data-services/custom-service/package-service';
import { FeedbackStudentGridResolver } from 'common/resolvers/page-resolvers/feedback-student/feedback-student.resolver';
import { FeedbackStudentsPreviewResolver } from 'common/resolvers/page-resolvers/feedback-mapping/feedback-students-preview.resolver';
import { RouterModule, Routes } from '@angular/router';
import { InternshipReportsResolver } from 'common/resolvers/page-resolvers/reports/internship-reports.resolver';
import { CreditReportsResolver } from 'common/resolvers/page-resolvers/reports/credit-reports.resolver';
import { AssignmentReportsResolver } from 'common/resolvers/page-resolvers/reports/assignment-reports.resolver';
import { MentorGridResolver } from 'common/resolvers/page-resolvers/mentor/mentor-grid.resolver';
import { MentorFormResolver } from 'common/resolvers/page-resolvers/mentor/mentor-form.resolver';
import { CompiledReportsResolver } from 'common/resolvers/page-resolvers/reports/compiled-reports.resolver';
import { PlacementReportsResolver } from 'common/resolvers/page-resolvers/reports/placement-reports.resolver';
import { MentorMappingGridResolver } from 'common/resolvers/page-resolvers/mentor-mapping/mentor-map-grid.resolver';
import { MentorMappingFormResolver } from 'common/resolvers/page-resolvers/mentor-mapping/mentor-map-form.resolver';
// import { StudentTotalListDataService } from 'common/widget/admin/student-list.service';
import { StudentAssignmentGridResolver } from 'common/resolvers/page-resolvers/student Assignment/student-assignment-resolver';
import { StudentTotalListDataService } from 'common/services/data-services/admin/applicants-dashboard/student-list.service';
import { BucketResolver } from 'common/resolvers/page-resolvers/preselection/admin/applicants/bucket.resolver';
import { stateListDataService } from 'common/services/data-services/custom-service/stateList-service.service';
import { StudentAssignmentDetailsResolver } from 'common/resolvers/page-resolvers/Student Assignment Details/student-assignment-deatils-resolver';
import { resendDocDataService } from 'common/services/data-services/admin/applicants-dashboard/resendUploadDoc.service';
import { LocationDeleteDataService } from 'common/services/data-services/admin/internship-company/company-location-delete-data.service';
import { MentorDeleteDataService } from 'common/services/data-services/admin/internship-company/company-mentor-delete-data.service';
import { MentorLogsGridResolver } from 'common/resolvers/page-resolvers/mentor/mentor-logs.resolver';
import { ApplicantStudentStatusUpdate } from 'common/services/data-services/admin/applicants-dashboard/applicant-StudentStatusUpdate.service';
import { DepartmentListDataService } from 'common/services/data-services/custom-service/department-list-service';
import { zoneListDataService } from 'common/services/data-services/custom-service/zoneList-service';
import { TypesDeleteDataService } from 'common/services/data-services/admin/types/types-delete-data.service';
import { TrainersStudentFormResolver } from 'common/resolvers/page-resolvers/Trainers-student/trainers-student-form.resolver';
import { AlumniResolver } from 'common/resolvers/page-resolvers/alumni/alumni-form.resolver';
import { editStudentDataService } from 'common/services/data-services/admin/applicants-dashboard/editStudentStatus.service';
import { StudentTrainerAssignmentGridResolver } from 'common/resolvers/page-resolvers/Student Trainer/student-trainer-assignment.resolver';
import { studentNotificationGridResolver } from 'common/resolvers/page-resolvers/student Notification/student-notification-resolver';
import { StudentInternshipDetailsResolver } from 'common/resolvers/page-resolvers/student-side/student-internship/student-internship-detail-resolver';
import { StudentInternshipGridResolver } from 'common/resolvers/page-resolvers/student-side/student-internship/student-internship-resolver';
import { UploaddocumentResolver } from 'common/resolvers/page-resolvers/preselection/admin/applicants/upload-document.resolver';
import { StudentFeedbackDataService } from 'common/services/data-services/student/student-internship/student-feedback-data.service';
import { StudentFeedbackQuestionsDataService } from 'common/services/data-services/student/student-internship/student-feedback-question-data.service';
import { InternshipListsGridResolver } from 'common/resolvers/page-resolvers/intership list/intership-list-student.resolver';
import { InternshipDetailsGridResolver } from 'common/resolvers/page-resolvers/intership list/intership-details-list.resolver';
import { AdminTravelReimbursementGridResolver } from 'common/resolvers/page-resolvers/travel-reimbursement/admin-travel-reimbursement-grid.resolver';
import { TravelDetailGridResolver } from 'common/resolvers/page-resolvers/travel-reimbursement/travel-detail-resolver';
import { ChangeMentorFormResolver } from 'common/resolvers/page-resolvers/mentor-mapping/change-mentor-resolver';
import { AddInternshipFormResolver } from 'common/resolvers/page-resolvers/intership list/addInternship-resolver';
import { UploadInternviewDataService } from 'common/services/data-services/admin/applicants-dashboard/upload-internview-score-data.service';
import { UploadAssessmentDataService } from 'common/services/data-services/admin/applicants-dashboard/upload-assessment-marks-data.service';
import { UploadHomeDataService } from 'common/services/data-services/admin/applicants-dashboard/upload-homevisit-score.service';
import { ApplicantDocumentListDataService } from 'common/services/data-services/admin/applicants-dashboard/applicant-document-list-data.service';
import { KtLogsGridResolver } from 'common/resolvers/page-resolvers/kt-logs/kt-logs.resolver';
import { EditFeedbackTitleDataService } from 'common/services/data-services/admin/feedback-mapping/editFeedbackTitle-data.service';
import { FeedbackStudentsFormResolver } from 'common/resolvers/page-resolvers/feedback-mapping/feedback-students-form-resolver';
import { EmailLogsGridResolver } from 'common/resolvers/page-resolvers/email-logs/email-logs.resolver';
import { IsEmailSendDataService } from 'common/services/data-services/admin/mentor/isEmailSend-data.service';
import { ImportStudentExcelDataService } from 'common/services/data-services/custom-service/import-student-excel.service';
import { InternshipResolver } from 'common/resolvers/page-resolvers/internship/internship.resolver';
import { InternshipFormDataService } from 'common/services/data-services/admin/internship/intership-form.service';
import { DashboardResolver } from 'common/resolvers/page-resolvers/dashboard/dashboard.resolver';
import { InternshipDeleteDataService } from 'common/services/data-services/admin/internship/internship-delete-data.service';
import { InternshipSendInviteDataService } from 'common/services/data-services/admin/internship/internship-sendInvite-data.service';
import { PrivacyResolver } from 'common/resolvers/page-resolvers/privacy/privacy.resolver';
import { ImportInternshipExcelDataService } from 'common/services/data-services/custom-service/import-internship.service';
import { InternshipReSendInviteDataService } from 'common/services/data-services/admin/internship/internship-reInvite-data.service';
import { MentoringReportsResolver } from 'common/resolvers/page-resolvers/reports/mentoring-reports.resolver';
import { ApplicantReportsResolver } from 'common/resolvers/page-resolvers/reports/applicant-reports.resolver';
import { InternshipTerminateStudentsDataService } from 'common/services/data-services/admin/internship/internship-terminate-students-data.service';
import { InternshipStudentListDataService } from 'common/services/data-services/admin/internship/internship-student-list.service';
import { InternshipBatchwiseDataService } from 'common/services/data-services/admin/internship/internship-batchwise-data.service';
import { MentorFeedbackResolver } from 'common/resolvers/page-resolvers/mentor-feedback/mentor-feedback.resolver';
import { StudentAvailabilityFormDataService } from 'common/services/data-services/admin/Intership-List/student-availability-form-data.service';
import { AppVersionGridResolver } from 'common/resolvers/page-resolvers/App Version/app-version-grid.resolver';
import { AppVersionFormResolver } from 'common/resolvers/page-resolvers/App Version/app-version-form.resolver';
import { DashboardComponent } from 'common/pages/dashboard/dashboard.component';
import { emailResetDataService } from 'common/services/data-services/admin/applicants-dashboard/email-reset.service';
import { DocumentReportsResolver } from 'common/resolvers/page-resolvers/reports/document-reports.resolver';
import { DepartmentListRegisterDataService } from 'common/services/data-services/custom-service/departmentListRegister.service';


const routes: Routes = [
  //login
  { path: '', redirectTo: 'admin/dashboard', pathMatch: 'full' },

  {
    path: 'admin/application/dashboard',
    loadChildren: () =>
      import(
        '../../common/pages/preselection/admin/applicant-dashboard/applicant-dashboard.module'
      ).then((m) => m.ApplicantDashboardModule),
    resolve: [applicantDashboardResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/dashboard',
    loadChildren: () =>
      import(
        '../../common/pages/dashboard/dashboard.module'
      ).then((m) => m.DashboardModule),
    resolve: [DashboardResolver],
    canActivate: [AuthGuard],
    data: { roles: [1, 4] },
  },


  {
    path: 'admin/applications/bucket',
    loadChildren: () =>
      import(
        '../../common/pages/preselection/admin/bucket/bucket.module'
      ).then((m) => m.BucketModule),
    resolve: [BucketResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/applications',
    loadChildren: () =>
      import(
        '../../common/pages/preselection/admin/applicants/applicants.module'
      ).then((m) => m.ApplicantsModule),
    resolve: [ApplicantsResolver],
    canActivate: [AuthGuard],
  },

  // {
  //   path: '',
  //   redirectTo: 'login',
  //   pathMatch: 'full',
  // },

  {
    path: 'privacynotice',
    loadChildren: () =>
      import('../../common/pages/privacy-notice/privacy-notice.module').then(
        (m) => m.PrivacyNoticeModule
      ),
    resolve: [PrivacyResolver],
  },

  {
    path: 'mentor-feedback',
    loadChildren: () =>
      import('../../common/pages/mentor-feedback/mentor-feedback.module').then(
        (m) => m.MentorFeedbackModule
      ),
    resolve: [MentorFeedbackResolver],
  },

  {
    path: 'login',
    loadChildren: () =>
      import('../../common/pages/login/login.module').then(
        (m) => m.LoginModule
      ),
    resolve: [LoginResolver],
  },

  {
    path: 'otp',
    loadChildren: () =>
      import('../../common/pages/otp-page/otp-page.module').then(
        (m) => m.OtpPageModule
      ),
    resolve: [OtpFormResolver],
  },
  {
    path: 'forgotpassword',
    loadChildren: () =>
      import(
        '../../common/pages/forgot-login-password/forgot-login-password.module'
      ).then((m) => m.ForgotLoginPasswordModule),
    resolve: [ForgotPasswordFormResolver],
  },
  {
    path: 'resetpassword',
    loadChildren: () =>
      import(
        '../../common/pages/reset-login-password/reset-login-password.module'
      ).then((m) => m.ResetLoginPasswordModule),
    resolve: [ResetForgotPasswordFormResolver],
  },

  //notification
  {
    path: 'admin/announcements',
    loadChildren: () =>
      import(
        '../../common/pages/notifications/notification-table/notification-table.module'
      ).then((m) => m.NotificationTableModule),
    resolve: [NotificationGridResolver],
    canActivate: [AuthGuard],
  },

  //email-logs
  {
    path: 'admin/email-logs',
    loadChildren: () =>
      import(
        '../../common/pages/email-logs/email-logs.module'
      ).then((m) => m.EmailLogsModule),
    resolve: [EmailLogsGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/announcements/add',
    loadChildren: () =>
      import(
        '../../common/pages/notifications/notification form/notification-form/notification-form.module'
      ).then((m) => m.NotificationFormModule),
    resolve: [NotificationFormResolver],
    canActivate: [AuthGuard],
  },
  //branches

  {
    path: 'admin/branches',
    loadChildren: () =>
      import(
        '../../common/pages/branches/branches-table/branches-table.module'
      ).then((m) => m.BranchesTableModule),
    resolve: [BranchesGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/branches/add',
    loadChildren: () =>
      import(
        '../../common/pages/branches/branches-form/branches-form.module'
      ).then((m) => m.BranchesFormModule),
    resolve: [BranchesFormResolver],
    canActivate: [AuthGuard],
  },

  //Branch Category Module
  {
    path: 'admin/branch-category',
    loadChildren: () =>
      import(
        '../../common/pages/branch-category/branch-category-grid/branch-category-grid.module'
      ).then((m) => m.BranchCategoryGridModule),
    resolve: [BranchCategoryGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/branch-category/add',
    loadChildren: () =>
      import(
        '../../common/pages/branch-category/branch-category-form/branch-category-form.module'
      ).then((m) => m.BranchCategoryFormModule),
    resolve: [BranchCategoryFormResolver],
    canActivate: [AuthGuard],
  },

  // Users Module
  {
    path: 'admin/users',
    loadChildren: () =>
      import('../../common/pages/users/users-grid/users-grid.module').then(
        (m) => m.UsersGridModule
      ),
    resolve: [UsersGridResolver],
  },

  {
    path: 'admin/users/add',
    loadChildren: () =>
      import('../../common/pages/users/users-form/users-form.module').then(
        (m) => m.UsersFormModule
      ),
    resolve: [UsersFormResolver],
  },

  // email template
  {
    path: 'admin/email-template',
    loadChildren: () =>
      import(
        '../../common/pages/email-template/email-template-grid/email-template-grid.module'
      ).then((m) => m.EmailTemplateGridModule),
    resolve: [EmailTemplateGridResolver],
  },

  {
    path: 'admin/add-edit-template',
    loadChildren: () =>
      import(
        '../../common/pages/email-template/email-template-form/email-template-form.module'
      ).then((m) => m.EmailTemplateFormModule),
    resolve: [EmailTemplateFormResolver],
  },

  // email template
  {
    path: 'admin/email-template',
    loadChildren: () =>
      import('../../common/pages/email-template/email-template-grid/email-template-grid.module').then(
        (m) => m.EmailTemplateGridModule
      ),
    resolve: [EmailTemplateGridResolver],
  },
  {
    path: 'admin/add-edit-template',
    loadChildren: () =>
      import('../../common/pages/email-template/email-template-form/email-template-form.module').then(
        (m) => m.EmailTemplateFormModule
      ),
    resolve: [EmailTemplateFormResolver],
  },

  //types

  {
    path: 'admin/categories',
    loadChildren: () =>
      import('../../common/pages/types/types-grid/types-grid.module').then(
        (m) => m.TypesGridModule
      ),
    resolve: [TypesGridResolver],
  },
  {
    path: 'admin/categories/add',
    loadChildren: () =>
      import('../../common/pages/types/types-form/types-form.module').then(
        (m) => m.TypesFormModule
      ),
    resolve: [TypesFormResolver],
  },

  //assignmentss
  {
    path: 'admin/assignments',
    loadChildren: () =>
      import(
        '../../common/pages/assignment-table/assignment-table.module'
      ).then((m) => m.AssignmentTableModule),
    resolve: [AssignmentGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/assignments/add',
    loadChildren: () =>
      import(
        '../../common/pages/assignment/assignment-form/assignment-form.module'
      ).then((m) => m.AssignmentFormModule),
    resolve: [AssignmentFormResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/edit-assignment/view-details',
    loadChildren: () =>
      import(
        '../../common/pages/assignment/assignment-form/assignment-form.module'
      ).then((m) => m.AssignmentFormModule),
    resolve: [AssignmentFormResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/assignment-invited',
    loadChildren: () =>
      import(
        '../../common/pages/assignment/invited-grid/invited-grid.module'
      ).then((m) => m.InvitedGridModule),
    resolve: [InvitedGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/assignment-accepted',
    loadChildren: () =>
      import(
        '../../common/pages/assignment/assignment-accepted/assignment-accepted.module'
      ).then((m) => m.AssignmentAcceptedModule),
    resolve: [AssigmentAcceptedGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/assignment-accepted',
    loadChildren: () =>
      import(
        '../../common/pages/assignment/assignment-accepted/assignment-accepted.module'
      ).then((m) => m.AssignmentAcceptedModule),
    resolve: [AssigmentAcceptedGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/students/logs',
    loadChildren: () =>
      import(
        '../../common/pages/kt-logs/kt-logs/kt-logs.module'
      ).then((m) => m.KtLogsModule),
    resolve: [KtLogsGridResolver],
    canActivate: [AuthGuard],
  },

  // {
  //   path: 'admin/assignment-accepted/:assignmentId',
  //   loadChildren: () =>
  //     import(
  //       '../../common/pages/assignment/assignment-accepted/assignment-accepted.module'
  //     ).then((m) => m.AssignmentAcceptedModule),
  //   resolve: [AssigmentAcceptedGridResolver],
  //   canActivate: [AuthGuard],
  // },
  {
    path: 'admin/assignment-non-accepted',
    loadChildren: () =>
      import(
        '../../common/pages/assignment/assignment-non-accepted/assignment-non-accepted.module'
      ).then((m) => m.AssignmentNonAcceptedModule),
    resolve: [AssigmentNotAcceptedGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/trainer-view',
    loadChildren: () =>
      import('../../common/pages/trainer-view/trainer-view.module').then(
        (m) => m.TrainerViewModule
      ),
    resolve: [TrainerViewGridResolver],
    canActivate: [AuthGuard],
  },
  //help
  {
    path: 'admin/helpcenter',
    loadChildren: () =>
      import('../../common/pages/help-centre/help-centre.module').then(
        (m) => m.HelpCentreModule
      ),
    resolve: [HelpFormResolver],
    canActivate: [AuthGuard],
  },
  // student-Profile
  {
    path: 'student/profile',
    loadChildren: () =>
      import('../../common/pages/student-profile/student-profile.module').then(
        (m) => m.StudentProfileModule
      ),
    resolve: [StudentProfileResolver],
    // canActivate: [AuthGuard],
  },

  //help
  {
    path: 'admin/helpcenter',
    loadChildren: () =>
      import('../../common/pages/help-centre/help-centre.module').then(
        (m) => m.HelpCentreModule
      ),
    resolve: [HelpFormResolver],
    canActivate: [AuthGuard],
  },
  // batches .....
  {
    path: 'admin/batches',
    loadChildren: () =>
      import(
        '../../common/pages/batches/batches-table/batches-table.module'
      ).then((m) => m.BatchesTableModule),
    resolve: [BatchesGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'batches/add',
    loadChildren: () =>
      import(
        '../../common/pages/batches/batches-form/batches-form.module'
      ).then((m) => m.BatchesFormModule),
    resolve: [BatchesFormResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'scholarship/apply',
    loadChildren: () =>
      import(
        '../../common/pages/preselection/admin/student/register/register.module'
      ).then((m) => m.RegisterModule),
    resolve: [RegisterFormResolver],
  },

  {
    path: 'admin/trainers',
    loadChildren: () =>
      import(
        '../../common/pages/Trainers/trainers-table/trainers-table.module'
      ).then((m) => m.TrainersTableModule),
    resolve: [TrainersGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/trainers/add',
    loadChildren: () =>
      import(
        '../../common/pages/Trainers/trainers-form/trainers-form.module'
      ).then((m) => m.TrainersFormModule),
    resolve: [TrainersFormResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/trainers/detail',
    loadChildren: () =>
      import(
        '../../common/pages/Trainers/view-trainers/view-trainers.module'
      ).then((m) => m.ViewTrainersModule),
    resolve: [ViewTrainersGridResolver],
  },

  {
    path: "trainer/profile",
    loadChildren: () =>
      import(
        '../../common/pages/Trainers-student/trainers-student-form/trainers-student-form.module'
      ).then((m) => m.TrainersStudentFormModule),
    resolve: [TrainersStudentFormResolver],
    canActivate: [AuthGuard],
  },



  {
    path: 'admin/students',
    loadChildren: () =>
      import(
        '../../common/pages/students/students-table/students-table.module'
      ).then((m) => m.StudentsTableModule),
    resolve: [StudentsGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/students/add',
    loadChildren: () =>
      import(
        '../../common/pages/students/students-form/students-form.module'
      ).then((m) => m.StudentsFormModule),
    resolve: [StudentsFormResolver],
  },

  {
    path: 'admin/studentdetail',
    loadChildren: () =>
      import('../../common/pages/student-details/student-details.module').then(
        (m) => m.StudentDetailsModule
      ),
    resolve: [StudentDetailsFormResolver],
  },

  {
    path: 'admin/assignment/details',
    loadChildren: () =>
      import(
        '../../common/pages/student-details/student-assignment-overview/student-assignment-overview.module'
      ).then((m) => m.StudentAssignmentOverviewModule),
    resolve: [StudentAssignmentOverviewResolver],
  },
  {
    path: 'dashboard',
    loadChildren: () =>
      import(
        '../../common/pages/alumni/alumni-form/alumni-form.module'
      ).then((m) => m.AlumniFormModule),
    resolve: [AlumniResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/trainers',
    loadChildren: () =>
      import(
        '../../common/pages/Trainers/trainers-table/trainers-table.module'
      ).then((m) => m.TrainersTableModule),
    resolve: [TrainersGridResolver],
  },
  {
    path: 'admin/trainers/add',
    loadChildren: () =>
      import(
        '../../common/pages/Trainers/trainers-form/trainers-form.module'
      ).then((m) => m.TrainersFormModule),
    resolve: [TrainersFormResolver],
  },

  // location
  {
    path: 'admin/locations',
    loadChildren: () =>
      import(
        '../../common/pages/location/location-table/location-table.module'
      ).then((m) => m.LocationTableModule),
    resolve: [LocationGridResolver],
  },
  {
    path: 'admin/locations/add',
    loadChildren: () =>
      import(
        '../../common/pages/location/location-form/location-form.module'
      ).then((m) => m.LocationFormModule),
    resolve: [LocationFormResolver],
  },

  //reports
  {
    path: 'admin/reports',
    loadChildren: () =>
      import(
        '../../common/pages/reports/reports-navigation/reports-navigation.module'
      ).then((m) => m.ReportsNavigationModule),
    resolve: [ReportsNavigationResolver],
  },
  {
    path: 'admin/reports/results',
    loadChildren: () =>
      import(
        '../../common/pages/reports/result-report/result-report.module'
      ).then((m) => m.ResultReportModule),
    resolve: [ResultReportsResolver],
  },
  {
    path: 'admin/reports/internship',
    loadChildren: () =>
      import(
        '../../common/pages/reports/internship-report/internship-report.module'
      ).then((m) => m.InternshipReportModule),
    resolve: [InternshipReportsResolver],
  },
  {
    path: 'admin/reports/credit',
    loadChildren: () =>
      import(
        '../../common/pages/reports/credit-report/credit-report.module'
      ).then((m) => m.CreditReportModule),
    resolve: [CreditReportsResolver],
  },
  {
    path: 'admin/reports/document',
    loadChildren: () =>
      import(
        '../../common/pages/reports/document-report/document-report.module'
      ).then((m) => m.DocumentReportModule),
    resolve: [DocumentReportsResolver],
  },
  {
    path: 'admin/reports/assignment',
    loadChildren: () =>
      import(
        '../../common/pages/reports/assignment-report/assignment-report.module'
      ).then((m) => m.AssignmentReportModule),
    resolve: [AssignmentReportsResolver],
  },
  {
    path: 'admin/reports/compiled',
    loadChildren: () =>
      import(
        '../../common/pages/reports/compiled-report/compiled-report.module'
      ).then((m) => m.CompiledReportModule),
    resolve: [CompiledReportsResolver],
  },
  {
    path: 'admin/reports/placement',
    loadChildren: () =>
      import(
        '../../common/pages/reports/placement-report/placement-report.module'
      ).then((m) => m.PlacementReportModule),
    resolve: [PlacementReportsResolver],
  },
  {
    path: 'admin/reports/mentorship',
    loadChildren: () =>
      import(
        '../../common/pages/reports/mentoring-report/mentoring-report.module'
      ).then((m) => m.MentoringReportModule),
    resolve: [MentoringReportsResolver],
  },
  {
    path: 'admin/reports/applicants',
    loadChildren: () =>
      import(
        '../../common/pages/reports/application-report/application-report.module'
      ).then((m) => m.ApplicationReportModule),
    resolve: [ApplicantReportsResolver],
  },
  // location
  {
    path: 'admin/locations',
    loadChildren: () =>
      import(
        '../../common/pages/location/location-table/location-table.module'
      ).then((m) => m.LocationTableModule),
    resolve: [LocationGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/locations/add',
    loadChildren: () =>
      import(
        '../../common/pages/location/location-form/location-form.module'
      ).then((m) => m.LocationFormModule),
    resolve: [LocationFormResolver],
    canActivate: [AuthGuard],
  },
  // travel-reimbursement
  {
    path: 'student/travel-reimbursement',
    loadChildren: () =>
      import(
        '../../common/pages/travel-reimbursement/travel-grid/travel-grid.module'
      ).then((m) => m.TravelGridModule),
    resolve: [TravelReimbursementGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'student/travel-reimbursement/add',
    loadChildren: () =>
      import(
        '../../common/pages/travel-reimbursement/travel-form/travel-form.module'
      ).then((m) => m.TravelFormModule),
    resolve: [TravelReimbursementFormResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/travel-reimbursement',
    loadChildren: () =>
      import(
        '../../common/pages/travel-reimbursement/admin-travel-reimbursement/admin-travel-reimbursement.module'
      ).then((m) => m.AdminTravelReimbursementModule),
    resolve: [AdminTravelReimbursementGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/travel-detail',
    loadChildren: () =>
      import(
        '../../common/pages/travel-reimbursement/travel-detail/travel-detail.module'
      ).then((m) => m.TravelDetailModule),
    resolve: [TravelDetailGridResolver],
    canActivate: [AuthGuard],
  },
  // mentoring-document
  {
    path: 'student/mentoring-document',
    loadChildren: () =>
      import(
        '../../common/pages/mentoring-doc/mentoring-grid/mentoring-grid.module'
      ).then((m) => m.MentoringGridModule),
    resolve: [MentoringDocumentGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'student/mentoring-document/add',
    loadChildren: () =>
      import(
        '../../common/pages/mentoring-doc/mentoring-form/mentoring-form.module'
      ).then((m) => m.MentoringFormModule),
    resolve: [MentoringDocumentFormResolver],
    canActivate: [AuthGuard],
  },

  // credit
  {
    path: 'admin/credit',
    loadChildren: () =>
      import(
        '../../common/pages/credit/credit-grid/credit-grid.module'
      ).then((m) => m.CreditGridModule),
    resolve: [CreditGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/credit/add',
    loadChildren: () =>
      import(
        '../../common/pages/credit/credit-form/credit-form.module'
      ).then((m) => m.CreditFormModule),
    resolve: [CreditFormResolver],
    canActivate: [AuthGuard],
  },

  // mentor
  {
    path: 'admin/mentor/list',
    loadChildren: () =>
      import(
        '../../common/pages/mentor-master/mentor-grid/mentor-grid.module'
      ).then((m) => m.MentorGridModule),
    resolve: [MentorGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/mentor/logs',
    loadChildren: () =>
      import(
        '../../common/pages/mentor-logs/mentor-logs.module'
      ).then((m) => m.MentorLogsModule),
    resolve: [MentorLogsGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/mentor/add',
    loadChildren: () =>
      import(
        '../../common/pages/mentor-master/mentor-form/mentor-form.module'
      ).then((m) => m.MentorFormModule),
    resolve: [MentorFormResolver],
    canActivate: [AuthGuard],
  },

  // mentor-mapping
  {
    path: 'admin/mentor-map/list',
    loadChildren: () =>
      import(
        '../../common/pages/mentor-mapping/mentor-mapping-grid/mentor-mapping-grid.module'
      ).then((m) => m.MentorMappingGridModule),
    resolve: [MentorMappingGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/mentor/map',
    loadChildren: () =>
      import(
        '../../common/pages/mentor-mapping/mentor-mapping-form/mentor-mapping-form.module'
      ).then((m) => m.MentorMappingFormModule),
    resolve: [MentorMappingFormResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/mentor/change',
    loadChildren: () =>
      import(
        '../../common/pages/mentor-mapping/change-mentor/change-mentor.module'
      ).then((m) => m.ChangeMentorModule),
    resolve: [ChangeMentorFormResolver],
    canActivate: [AuthGuard],
  },

  //reports
  {
    path: 'admin/reports',
    loadChildren: () =>
      import(
        '../../common/pages/reports/reports-navigation/reports-navigation.module'
      ).then((m) => m.ReportsNavigationModule),
    resolve: [ReportsNavigationResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/reports/results',
    loadChildren: () =>
      import(
        '../../common/pages/reports/result-report/result-report.module'
      ).then((m) => m.ResultReportModule),
    resolve: [ResultReportsResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/internshipdetails',
    loadChildren: () =>
      import(
        '../../common/pages/student-intenrship-details/student-intenrship-details.module'
      ).then((m) => m.StudentIntenrshipDetailsModule),
    resolve: [InternshipDetailsFormResolver],
    canActivate: [AuthGuard],
  },

  //Internship Company
  {
    path: 'admin/intern-company',
    loadChildren: () =>
      import(
        '../../common/pages/internship-company/internship-company.module'
      ).then((m) => m.InternshipCompanyModule),
    resolve: [CompanyGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/company/add',
    loadChildren: () =>
      import('../../common/pages/company-form/company-form.module').then(
        (m) => m.CompanyFormModule
      ),
    resolve: [CompanyFormResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/location/:companyId',
    loadChildren: () =>
      import(
        '../../common/pages/company-location/company-location.module'
      ).then((m) => m.CompanyLocationModule),
    resolve: [CompanyLocationGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/mentor/:companyId',
    loadChildren: () =>
      import('../../common/pages/mentor/mentor.module').then(
        (m) => m.MentorModule
      ),
    resolve: [CompanyMentorGridResolver],
    canActivate: [AuthGuard],
  },
  //Groups
  {
    path: 'admin/groups',
    loadChildren: () =>
      import('../../common/pages/groups/groups/groups.module').then(
        (m) => m.GroupsModule
      ),
    resolve: [GroupsGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/groups/details',
    loadChildren: () =>
      import(
        '../../common/pages/groups/groups/group-detail/group-detail.module'
      ).then((m) => m.GroupDetailModule),
    resolve: [GroupDetailResolver],
    canActivate: [AuthGuard],
  },

  // {
  //   path: 'intern/studentlist',
  //   loadChildren: () =>
  //     import(
  //       '../../common/pages/internship/student-list-table/student-list-table.module'
  //     ).then((m) => m.StudentListTableModule),
  //   resolve: [StudentListGridResolver],
  // },

  {
    path: 'intern/intern',
    loadChildren: () =>
      import(
        '../../common/pages/internship/internship/internship.module'
      ).then((m) => m.InternshipModule),
    resolve: [InternshipResolver],
  },

  {
    path: 'admin/feedback',
    loadChildren: () =>
      import(
        '../../common/pages/feedback-/feedback-grid/feedback-grid.module'
      ).then((m) => m.FeedbackGridModule),
    resolve: [FeedbackGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/feedback/add',
    loadChildren: () =>
      import('../../common/pages/feedback-/feedback/feedback.module').then(
        (m) => m.FeedbackModule
      ),
    resolve: [FeedbackFormResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/feedback/preview',
    loadChildren: () =>
      import(
        '../../common/pages/feedback-/feedback-preview/feedback-preview.module'
      ).then((m) => m.FeedbackPreviewModule),
    resolve: [FeedbackPreviewResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/feedback/students',
    loadChildren: () =>
      import(
        '../../common/pages/feedback-student-list/feedback-student-list/feedback-student-list.module'
      ).then((m) => m.FeedbackStudentListModule),
    resolve: [FeedbackStudentGridResolver],
    canActivate: [AuthGuard],
  },

  //feedback mapping
  {
    path: 'admin/feedbacklist',
    loadChildren: () =>
      import(
        '../../common/pages/feedback-mapping/feedback-mapping-grid/feedback-mapping-grid.module'
      ).then((m) => m.FeedbackMappingGridModule),
    resolve: [FeedbackMappingGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/feedbackform/add',
    loadChildren: () =>
      import(
        '../../common/pages/feedback-mapping/feedback-mapping-form/feedback-mapping-form.module'
      ).then((m) => m.FeedbackMappingFormModule),
    resolve: [FeedbackMappingFormResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/feedback/students/preview',
    loadChildren: () =>
      import(
        '../../common/pages/feedback-student-list/feedback-student-preview/feedback-student-preview.module'
      ).then((m) => m.FeedbackStudentPreviewModule),
    resolve: [FeedbackStudentsPreviewResolver],
    canActivate: [AuthGuard],
  },




  // student feedback 
  {
    path: 'student/Feedback',
    loadChildren: () =>
      import(
        '../../common/pages/student-feedback/student-feedback.module'
      ).then((m) => m.StudentFeedbackModule),
    resolve: [studentFeedbackGridResolver],
    canActivate: [AuthGuard],
  },

  //Internship
  {
    path: 'admin/internship/internship-list',
    loadChildren: () =>
      import(
        '../../common/pages/internship/internship-list/internship-list.module'
      ).then((m) => m.InternshipListModule),
    resolve: [InternshipListGridResolver],
  },

  // student Assignment

  {
    path: 'student/assignments',
    loadChildren: () =>
      import(
        '../../common/pages/student-assignment/student-assignment.module'
      ).then((m) => m.StudentAssignmentModule),
    resolve: [StudentAssignmentGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'student/assignments/details',
    loadChildren: () =>
      import(
        '../../common/pages/student-assignment-details/student-assignment-details.module'
      ).then((m) => m.StudentAssignmentDetailsModule),
    resolve: [StudentAssignmentDetailsResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'trainer/assignment',
    loadChildren: () =>
      import(
        '../../common/pages/student-trainer-assignment/student-trainer-assignment.module'
      ).then((m) => m.StudentTrainerAssignmentModule),
    resolve: [StudentTrainerAssignmentGridResolver],
  },
  {
    path: 'student/internship',
    loadChildren: () =>
      import(
        '../../common/pages/student-side/student-internship/student-internship.module'
      ).then((m) => m.StudentInternshipModule),
    resolve: [StudentInternshipGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'student/availabilty',
    loadChildren: () =>
      import(
        '../../common/pages/student-side/student-internship-details/student-internship-details.module'
      ).then((m) => m.StudentInternshipDetailsModule),
    resolve: [StudentInternshipDetailsResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'student/complete-internship',
    loadChildren: () =>
      import(
        '../../common/pages/student-side/complete-internship-detail/complete-internship-detail.module'
      ).then((m) => m.CompleteInternshipDetailModule),
    resolve: [StudentInternshipDetailsResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'admin/applications/upload',
    loadChildren: () =>
      import(
        '../../common/pages/preselection/admin/upload-documents/upload-documents.module'
      ).then((m) => m.UploadDocumentsModule),
    resolve: [UploaddocumentResolver],
    // canActivate: [AuthGuard],
  },


  {
    path: 'student/announcements',
    loadChildren: () =>
      import(
        '../../common/pages/student-notification/student-notification.module'
      ).then((m) => m.StudentNotificationModule),
    resolve: [studentNotificationGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'student/in-complete-internship',
    loadChildren: () =>
      import(
        '../../common/pages/student-side/incomplete-internship/incomplete-internship.module'
      ).then((m) => m.IncompleteInternshipModule),
    resolve: [StudentInternshipDetailsResolver],
    // intership student list
  },

  {
    path: 'admin/internship-student-list',
    loadChildren: () =>
      import(
        '../../common/pages/Internship-Student-list/intership-student-filter-list/intership-student-list/intership-student-list.module'
      ).then((m) => m.IntershipStudentListModule),
    resolve: [InternshipListsGridResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'student/internship-details',
    loadChildren: () =>
      import(
        '../../common/pages/student-side/internship-assigned/internship-assigned.module'
      ).then((m) => m.InternshipAssignedModule),
    resolve: [StudentInternshipDetailsResolver],
  },
  {
    path: 'admin/internship-students',
    loadChildren: () =>
      import(
        '../../common/pages/Internship-Student-list/intership-student-filter-list/intership-details/intership-details.module'
      ).then((m) => m.IntershipDetailsModule),
    resolve: [InternshipDetailsGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/addInternship',
    loadChildren: () =>
      import(
        '../../common/pages/Internship-Student-list/intership-student-filter-list/add-internship/add-internship.module'
      ).then((m) => m.AddInternshipModule),
    resolve: [AddInternshipFormResolver],
    canActivate: [AuthGuard],
  },

  {
    path: 'student/Feedback/add',
    loadChildren: () =>
      import(
        '../../common/pages/feedback-student-list/feedback-student-form/feedback-student-form.module'
      ).then((m) => m.FeedbackStudentFormModule),
    resolve: [FeedbackStudentsFormResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/appManagement',
    loadChildren: () =>
      import(
        '../../common/pages/app-version/app-version-table/app-version.module'
      ).then((m) => m.AppVersionModule),
    resolve: [AppVersionGridResolver],
    canActivate: [AuthGuard],
  },
  {
    path: 'admin/appManagement/edit',
    loadChildren: () =>
      import(
        '../../common/pages/app-version/app-version-form/app-version-form.module'
      ).then((m) => m.AppVersionFormModule),
    resolve: [AppVersionFormResolver],
    canActivate: [AuthGuard],
  },
  {
    path: '**',
    redirectTo: 'admin/dashboard',
  },

];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
  providers: [documentListDataService, ImportStudentExcelDataService, packageListDataService, IsEmailSendDataService, InternshipFormDataService, StudentTotalListDataService, stateListDataService, resendDocDataService, LocationDeleteDataService, MentorDeleteDataService, ApplicantStudentStatusUpdate, DepartmentListDataService,DepartmentListRegisterDataService, zoneListDataService, editStudentDataService, StudentFeedbackDataService, StudentFeedbackQuestionsDataService, resendDocDataService,emailResetDataService , UploadInternviewDataService, UploadAssessmentDataService, UploadHomeDataService, ApplicantDocumentListDataService, EditFeedbackTitleDataService, InternshipDeleteDataService, InternshipSendInviteDataService, InternshipReSendInviteDataService, InternshipBatchwiseDataService, ImportInternshipExcelDataService, InternshipTerminateStudentsDataService, StudentAvailabilityFormDataService,DepartmentListRegisterDataService],
})
export class AppRoutingModule { }
